/**
 * 远程诊断模块词表(远程运维控制台单页 + 台账详情页远程诊断区块共用前缀
 * pages.deviceOps.*;菜单键见 menu.ts)。状态机/规则码文案对应后端
 * model/deviceops.go 常量面与方案 §3.5/§5.2。2026-10-14 四页合一:
 * 旧指令中心/设备日志/数据库运维三页下线,command.* 词表由控制台的
 * 指令台账抽屉(LedgerDrawer)与写操作二次确认(ConfirmModal)沿用,
 * db.write.* 仅保留控制台结果渲染在用的条目。
 */
export default {
  // ===== 共用 =====
  'pages.deviceOps.deviceSelect.placeholder':
    '搜索并选择设备(名称/编码/序列号/租户/门店)',
  'pages.deviceOps.deviceSelect.tenant': '租户',
  'pages.deviceOps.deviceSelect.store': '门店',
  'pages.deviceOps.deviceSelect.selectedFallback': '已选设备',
  'pages.deviceOps.type.DEVICE_STATE': '设备状态快照',
  'pages.deviceOps.type.LOG_LIST': '日志文件清单',
  'pages.deviceOps.type.LOG_QUERY': '日志过滤查询',
  'pages.deviceOps.type.DB_TABLES': '数据库表清单',
  'pages.deviceOps.type.DB_READ': '数据库只读查询',
  'pages.deviceOps.type.DB_BACKUP': '数据库备份',
  'pages.deviceOps.type.DB_WRITE': '数据库受控写',
  'pages.deviceOps.type.SIGN_RESET': '签名凭证重置',
  'pages.deviceOps.risk.READ': '只读',
  'pages.deviceOps.risk.BACKUP': '备份',
  'pages.deviceOps.risk.WRITE': '写操作',
  'pages.deviceOps.risk.MEDIUM': '中风险(触本地安全数据)',
  'pages.deviceOps.status.PENDING_CONFIRM': '待二次确认',
  'pages.deviceOps.status.CREATED': '已入队',
  'pages.deviceOps.status.DELIVERED': '设备已认领',
  'pages.deviceOps.status.EXECUTING': '执行中',
  'pages.deviceOps.status.DONE': '执行成功',
  'pages.deviceOps.status.FAILED': '执行失败',
  'pages.deviceOps.status.FAILED_DELIVERY': '投递失败(重投耗尽)',
  'pages.deviceOps.status.FAILED_TIMEOUT': '执行超时',
  'pages.deviceOps.status.REJECTED_ROW_LIMIT': '命中行数超限已回滚',
  'pages.deviceOps.status.REJECTED_VALIDATION': '校验被拒(已留痕)',
  'pages.deviceOps.status.SKIPPED_DEVICE_BUSY': '设备忙延后',
  'pages.deviceOps.status.CANCELED': '已取消',
  'pages.deviceOps.status.EXPIRED': '已过期',
  'pages.deviceOps.rejectRule.R-SQL-MULTI': '多语句被拒',
  'pages.deviceOps.rejectRule.R-SQL-TYPE': '语句类型被拒',
  'pages.deviceOps.rejectRule.R-SQL-TABLE': '目标表不在白名单',
  'pages.deviceOps.rejectRule.R-SQL-NOWHERE': '缺少 WHERE 条件',
  'pages.deviceOps.rejectRule.R-SQL-PRAGMA': '禁用语句族(PRAGMA/DDL 等)',
  'pages.deviceOps.rejectRule.R-SQL-PARAM': '占位符/参数不合规',
  'pages.deviceOps.rejectRule.R-SQL-LIMIT': 'LIMIT 超上限',
  // 台账详情页远程诊断区块
  'pages.deviceOps.detail.sectionTitle': '远程诊断',
  'pages.deviceOps.detail.onlineStatus': '在线状态',
  'pages.deviceOps.detail.online': '在线',
  'pages.deviceOps.detail.offline': '离线',
  'pages.deviceOps.detail.lastOnlineTime': '最近心跳',
  'pages.deviceOps.detail.pendingTitle': '在途指令',

  // ===== 指令台账与二次确认(原指令中心页词表,由控制台 LedgerDrawer/ConfirmModal 沿用) =====
  'pages.deviceOps.command.title': '远程运维指令中心',
  'pages.deviceOps.command.confirm.title': '写操作二次确认',
  'pages.deviceOps.command.confirm.ok': '确认下发',
  'pages.deviceOps.command.confirm.cancel': '取消',
  'pages.deviceOps.command.confirm.success': '已确认,指令进入队列等待设备拉取',
  'pages.deviceOps.command.confirm.conflict':
    '指令状态已变化(可能已被确认/取消),请刷新列表',
  'pages.deviceOps.command.confirm.riskTitle':
    '高危操作:将直接改动设备本地数据库',
  'pages.deviceOps.command.confirm.riskDesc':
    '设备端执行前将自动做三件套备份(PPOS.db/-wal/-shm);若命中行数超过限额将自动回滚并不执行。请逐字核对下方规范化语句与参数。',
  'pages.deviceOps.command.confirm.expectMaxRows': '命中行数限额',
  'pages.deviceOps.command.confirm.sqlTitle': '规范化语句(所见即所执行)',
  'pages.deviceOps.command.confirm.paramsTitle': '参数',
  'pages.deviceOps.command.confirm.auditNote':
    '确认动作与语句哈希(sqlHash)将写入审计台账;确认后任何端不可再改动该指令载荷。',
  'pages.deviceOps.command.confirm.cooldown':
    '安全冷却中,请 {seconds} 秒后再确认',
  'pages.deviceOps.command.cancel.success': '指令已取消',
  'pages.deviceOps.command.cancel.conflict': '指令已投递或已终态,无法取消',
  'pages.deviceOps.command.cancel.confirmTitle': '取消该指令?',
  'pages.deviceOps.command.cancel.confirmDesc':
    '仅未投递(待确认/已入队)的指令可取消;取消动作同样留痕。',
  'pages.deviceOps.command.action.detail': '详情',
  'pages.deviceOps.command.action.confirm': '确认',
  'pages.deviceOps.command.action.cancel': '取消',
  'pages.deviceOps.command.column.commandNo': '指令单号',
  'pages.deviceOps.command.column.deviceCode': '设备编码',
  'pages.deviceOps.command.column.deviceCodePlaceholder': '精确匹配',
  'pages.deviceOps.command.column.deviceId': '设备 ID',
  'pages.deviceOps.command.column.tenant': '所属租户',
  'pages.deviceOps.command.column.store': '所属门店',
  'pages.deviceOps.command.column.type': '指令类型',
  'pages.deviceOps.command.column.typePlaceholder': '请选择类型',
  'pages.deviceOps.command.column.risk': '风险级',
  'pages.deviceOps.command.column.status': '状态',
  'pages.deviceOps.command.column.statusPlaceholder': '请选择状态',
  'pages.deviceOps.command.column.rejectRule': '被拒规则',
  'pages.deviceOps.command.column.rowsAffected': '影响行数',
  'pages.deviceOps.command.column.createdByName': '创建人',
  'pages.deviceOps.command.column.createdReason': '操作原因',
  'pages.deviceOps.command.column.createdAt': '创建时间',
  'pages.deviceOps.command.column.createdAtRange': '创建时间范围',
  'pages.deviceOps.command.column.deliveredAt': '投递时间',
  'pages.deviceOps.command.column.finishedAt': '完结时间',
  'pages.deviceOps.command.column.action': '操作',
  'pages.deviceOps.command.detail.title': '指令详情',
  'pages.deviceOps.command.detail.expectMaxRows': '命中行数限额',
  'pages.deviceOps.command.detail.timeoutSeconds': '超时(秒)',
  'pages.deviceOps.command.detail.tryCount': '投递计数',
  'pages.deviceOps.command.detail.redeliverCount': '重投计数',
  'pages.deviceOps.command.detail.rowsAffected': '影响行数',
  'pages.deviceOps.command.detail.payloadTitle':
    '指令载荷(创建时落库,确认后不可改)',
  'pages.deviceOps.command.detail.sqlTitle': '规范化 SQL 与哈希',
  'pages.deviceOps.command.detail.deviceMetaTitle': '设备回报元信息',
  'pages.deviceOps.command.detail.resultsTitle': '执行结果分片',
  'pages.deviceOps.command.detail.rowsAffectedShort': '影响行数',
  'pages.deviceOps.command.detail.downloadResult': '下载产物',
  'pages.deviceOps.command.detail.noResults':
    '暂无结果分片(设备尚未回报或该指令无产物)',
  'pages.deviceOps.command.detail.refreshHint':
    '指令未到终态,关闭后重新打开详情可刷新进度。',
  'pages.deviceOps.command.detail.auditNote':
    '本页所有创建/确认/取消动作均已写入操作日志与指令台账,留存 180 天。',

  // ===== 数据库运维(原运维台词表,仅保留控制台在用条目:结果渲染/超限回滚/确认提示) =====
  'pages.deviceOps.db.write.audit.expectMaxRowsNote': '设备端超限自动回滚',
  'pages.deviceOps.db.write.rowLimitTitle': '设备端拒绝:命中行数超限',
  'pages.deviceOps.db.write.rowLimitDesc':
    '设备按同条件核对命中 {actual} 行,超过限额 {limit},已整体回滚未写任何数据。请人工评估后按需以更高限额重发新指令。',
  'pages.deviceOps.db.write.result.backup': '备份文件',
  'pages.deviceOps.db.write.result.finishedAt': '完结时间',
  'pages.deviceOps.db.write.result.tookMs': '耗时',
  'pages.deviceOps.db.write.result.countMatched': '行数核对',

  // ===== 远程运维控制台 =====
  'pages.deviceOps.console.title': '运维控制台',
  'pages.deviceOps.console.subtitle':
    '以单台设备为中心的命令行运维窗口:命令串行下发(忙时可继续输入排队),状态/结果/审计单号全程留痕;复用远程诊断指令通道,后端零改动',
  'pages.deviceOps.console.device': '目标设备',
  'pages.deviceOps.console.deviceOnlineOnly': '在线',
  'pages.deviceOps.console.pendingOthers': '其他来源在途 {count} 条',
  'pages.deviceOps.console.transcript.empty':
    '会话为空:输入 help 查看命令;命令将按序串行下发,结果展示在对应条目下',
  'pages.deviceOps.console.input.placeholder':
    '输入命令(如 help / state / tables / log query --since 1h / SELECT …),Ctrl+Enter 运行',
  'pages.deviceOps.console.input.run': '运行',
  'pages.deviceOps.console.sessionDark.toggle': '会话深色模式',
  'pages.deviceOps.console.fullscreen.enter': '全屏展示',
  'pages.deviceOps.console.fullscreen.exit': '退出全屏',
  'pages.deviceOps.console.input.queued': '排队 {count} 条',
  'pages.deviceOps.console.status.queued': '排队中',
  'pages.deviceOps.console.status.waitingSecs': '已等待 {seconds} s',
  'pages.deviceOps.console.status.rhythmBoost': '加速轮询 ≈{seconds}s',
  'pages.deviceOps.console.status.rhythmBoostPlain': '加速轮询',
  'pages.deviceOps.console.status.wakeHint': '等待设备轮询',
  'pages.deviceOps.console.status.wakeHintTip':
    '加速参数随设备轮询响应下发(无推送通道):设备正按基础间隔轮询,本条指令将在其下次轮询时被认领,首条指令可能需等待数分钟;认领后及加速窗口内的后续指令为秒级响应。',
  'pages.deviceOps.console.status.rhythmDefault': '默认轮询,最长约 5 min',
  'pages.deviceOps.console.entry.continued': '续拉',
  'pages.deviceOps.console.entry.systemPrefix': '系统:',
  'pages.deviceOps.console.entry.parseErrorPrefix': '命令解析失败:',
  'pages.deviceOps.console.help.title': '可用命令(help)',
  'pages.deviceOps.console.help.body':
    'state · tables · logs —— 设备状态快照 / 数据库表清单 / 日志文件清单\nbackup · backup list —— 拍三件套快照 / 查看备份清单\nsign reset [re-enroll|reactivate] —— 远程修复签名凭证(缺省 re-enroll=仅重注册;reactivate=完整重激活)\nls [tables|logs] —— 别名:表清单 / 日志文件清单(缺省 tables)\ngrep <关键字> [筛选项] —— 别名:按关键字查日志(同 log query 旗标)\ncat <error|biz>_YYYY-MM-DD.txt —— 别名:查看指定日期日志文件(缺省当日窗口)\nlog query [--kind error|biz] [--level L] [--tag T] [--grep K] [--file F] [--limit 1~200] [--since 1h|6h|24h 或 --from/--to YYYY-MM-DDTHH:mm:ss(互斥)]\nSELECT … —— 只读查询(服务端校验并注入 LIMIT 500;不带参数占位符)\nUPDATE/DELETE … —— 受控写(提交时输入固定密码二次确认;入队后二段确认,30s 冷却;INSERT/REPLACE/BEGIN 事务脚本同走写通道原文透传,多行 Shift+Enter 换行)\ncancel —— 取消当前未投递条目 · clear —— 清空会话 · help —— 本帮助',
  'pages.deviceOps.console.help.writePwdNote':
    'UPDATE/DELETE 直通:提交后需输入固定密码二次确认(仅前端校验)',
  'pages.deviceOps.console.msg.pickDevice': '请先选择设备',
  'pages.deviceOps.console.msg.createFailed': '创建指令失败',
  'pages.deviceOps.console.msg.writePwdWrong': '密码不正确',
  'pages.deviceOps.console.writePwd.title': '受控写二次确认',
  'pages.deviceOps.console.writePwd.tip':
    '即将下发 UPDATE/DELETE 写指令,请输入固定密码确认(仅前端校验):',
  'pages.deviceOps.console.writePwd.ok': '确认下发',
  'pages.deviceOps.console.writePwd.placeholder': '请输入密码',
  'pages.deviceOps.console.msg.trackingTimeout':
    '本地跟踪超过 5 分钟已停止轮询;最新状态请在「指令台账」中查看',
  'pages.deviceOps.console.cancel.nothing':
    '没有可取消的条目(仅未投递的待确认/已入队指令可取消)',
  'pages.deviceOps.console.cancel.success': '指令已取消',
  'pages.deviceOps.console.cancel.conflict': '取消失败:指令已投递或已到终态',
  'pages.deviceOps.console.cancel.failed': '取消失败:{reason}',
  'pages.deviceOps.console.clear.blocked':
    '仍有在途/待确认条目:请先 cancel 或等待终态后再清空会话',
  'pages.deviceOps.console.confirm.title': '写操作待二次确认(30s 冷却后可确认)',
  'pages.deviceOps.console.confirm.normalizedSql': '规范化语句(所见即所执行)',
  'pages.deviceOps.console.confirm.sqlHash': 'sqlHash',
  'pages.deviceOps.console.confirm.backupPath': '备份目录',
  'pages.deviceOps.console.confirm.expectMaxRows': '影响行数限额',
  'pages.deviceOps.console.confirm.ackBackup':
    '已读:执行前设备端将自动生成三件套快照备份(OpsBackup/单号/)',
  'pages.deviceOps.console.confirm.ackRollback':
    '自担:命中行数超限自动回滚;若实际执行,影响不可远程撤销',
  'pages.deviceOps.console.confirm.submit': '确认执行',
  'pages.deviceOps.console.confirm.cooldown': '冷却中 {seconds}s',
  'pages.deviceOps.console.confirm.conflict':
    '确认冲突:指令状态已变化,已刷新展示',
  'pages.deviceOps.console.confirm.success': '已确认下发,等待设备拉取执行',
  'pages.deviceOps.console.confirm.failed': '确认失败:{reason}',
  'pages.deviceOps.console.confirm.rejectedTitle': 'SQL 校验被拒(已落库留痕)',
  'pages.deviceOps.console.result.loading': '拉取结果分片…',
  'pages.deviceOps.console.result.empty': '无结果产物',
  'pages.deviceOps.console.result.continue': '继续拉取',
  'pages.deviceOps.console.result.truncated':
    '本页结果被截断(单次扫描预算达上限):建议收窄时间窗后继续拉取',
  'pages.deviceOps.console.reason.continuedSuffix': '(游标续拉)',
  // 结果块结构化列/摘要(2026-10-19 展示改造:按设备真实信封形态)
  'pages.deviceOps.console.result.tableName': '表名',
  'pages.deviceOps.console.result.typeCol': '类型',
  'pages.deviceOps.console.result.typeTable': '表',
  'pages.deviceOps.console.result.typeView': '视图',
  'pages.deviceOps.console.result.objectCount': '共 {count} 个对象',
  'pages.deviceOps.console.result.fileName': '文件名',
  'pages.deviceOps.console.result.kindCol': '类型',
  'pages.deviceOps.console.result.dateCol': '日期',
  'pages.deviceOps.console.result.sizeCol': '大小',
  'pages.deviceOps.console.result.fileCount': '{count} 个文件',
  'pages.deviceOps.console.result.retentionDays': '保留 {retentionDays} 天',
  'pages.deviceOps.console.result.truncatedRows':
    '结果超出分片/行数预算被截断(已显示前 {rowsAffected} 行)',
  // 设备状态快照摘要卡(DEVICE_STATE)
  'pages.deviceOps.console.state.appVersion': '应用版本',
  'pages.deviceOps.console.state.generatedAt': '生成时间',
  'pages.deviceOps.console.state.networkStatus': '网络状态',
  'pages.deviceOps.console.state.diskFree': '磁盘剩余',
  'pages.deviceOps.console.state.dbSize': '本地库大小',
  'pages.deviceOps.console.state.dbPath': '库路径',
  'pages.deviceOps.console.state.activation': '激活快照',
  'pages.deviceOps.console.state.statErrorTitle': '状态采集失败',
  // 数据库备份摘要/清单(DB_BACKUP)
  'pages.deviceOps.console.backup.col.commandNo': '备份名',
  'pages.deviceOps.console.backup.col.total': '合计',
  'pages.deviceOps.console.backup.col.mtime': '修改时间',
  'pages.deviceOps.console.backup.col.quickCheck': '完整性',
  'pages.deviceOps.console.backup.keepSummary':
    '保留最近 {keep} 组 · 根目录 {root}',
  'pages.deviceOps.console.backup.backupDir': '备份目录',
  'pages.deviceOps.console.backup.tripleBytes': '三件套大小',
  'pages.deviceOps.console.backup.quickCheck': '完整性',
  'pages.deviceOps.console.backup.copyMs': '备份耗时',
  'pages.deviceOps.console.backup.checkMs': '校验耗时',
  'pages.deviceOps.console.backup.pruned': '清理旧备份',
  'pages.deviceOps.console.backup.prunedCount': '{count} 组',
  'pages.deviceOps.console.backup.prunedNone': '无',
  // 签名重置摘要(SIGN_RESET)
  'pages.deviceOps.console.signreset.mode': '模式',
  'pages.deviceOps.console.signreset.tookMs': '耗时',
  'pages.deviceOps.console.signreset.summary': '结果',

  // ===== 临时加速轮询(方案 §3.3.2 频率动态化;控制台自动挂加速+台账详情手动挂载) =====
  'pages.deviceOps.boost.scene.console': '运维控制台',
  'pages.deviceOps.boost.autoReason': '工作台打开自动加速({scene})',
  'pages.deviceOps.boost.renewReason': '手动续期加速({scene})',
  'pages.deviceOps.boost.activeTag': '加速轮询生效中',
  'pages.deviceOps.boost.intervalLabel': '频率',
  'pages.deviceOps.boost.remainingLabel': '剩余',
  'pages.deviceOps.boost.untilLabel': '到期',
  'pages.deviceOps.boost.grantedByLabel': '挂载人',
  'pages.deviceOps.boost.reasonLabel': '原因:',
  'pages.deviceOps.boost.renew': '续期 10 分钟',
  'pages.deviceOps.boost.revoke': '解除加速',
  'pages.deviceOps.boost.revokeConfirmTitle': '解除该设备的加速?',
  'pages.deviceOps.boost.revokeConfirmDesc':
    '解除后设备下一次轮询即恢复默认间隔;并发加速额度随之释放。',
  'pages.deviceOps.boost.revokeSuccess': '已解除,设备下一次轮询即恢复默认间隔',
  'pages.deviceOps.boost.revokeConflict': '无在效加速(可能已到期或已被解除)',
  'pages.deviceOps.boost.degradedTitle': '已达加速限额,未自动加速',
  'pages.deviceOps.boost.degradedHint':
    '当前按默认间隔轮询,指令时延可能达数分钟;功能不受影响。可在下方生效中加速面板解除自己名下的其他加速后重试。',
  'pages.deviceOps.boost.expiredTitle': '加速已到期',
  'pages.deviceOps.boost.expiredHint':
    '设备已恢复默认轮询间隔;仍需秒级响应可重新加速。',
  'pages.deviceOps.boost.reBoost': '重新加速',
  'pages.deviceOps.boost.grantSuccess':
    '已挂载加速,等待设备下一次轮询生效(默认间隔下最坏约 5 分钟)',
  'pages.deviceOps.boost.auditNote':
    '挂载/续期/解除均写入操作审计(操作者/时间/设备/频率/时长/原因)。',
  // 指令中心·生效中加速面板(§3.3.2-③ 一键解除释放并发额度)
  'pages.deviceOps.boost.panel.title': '生效中加速',
  'pages.deviceOps.boost.panel.refresh': '刷新',
  'pages.deviceOps.boost.panel.empty': '暂无生效中加速',
  'pages.deviceOps.boost.panel.device': '设备',
  'pages.deviceOps.boost.panel.tenant': '所属租户',
  'pages.deviceOps.boost.panel.store': '所属门店',
  'pages.deviceOps.boost.panel.interval': '频率',
  'pages.deviceOps.boost.panel.remaining': '剩余',
  'pages.deviceOps.boost.panel.grantedBy': '挂载人',
  'pages.deviceOps.boost.panel.grantedAt': '挂载时间',
  'pages.deviceOps.boost.panel.lastPollAt': '最近 poll',
  'pages.deviceOps.boost.panel.reason': '原因',
  'pages.deviceOps.boost.panel.action': '操作',
  'pages.deviceOps.boost.panel.revoke': '解除',
  'pages.deviceOps.boost.panel.others': '他人挂载',
  // 台账详情页·临时加速轮询操作(选频率+时长+审计原因,剩余生效时间展示)
  'pages.deviceOps.detail.boost.action': '临时加速轮询',
  'pages.deviceOps.detail.boost.status': '加速轮询',
  'pages.deviceOps.detail.boost.idle': '默认间隔',
  'pages.deviceOps.detail.boost.submit': '挂载加速',
  'pages.deviceOps.detail.boost.cancel': '取消',
  'pages.deviceOps.detail.boost.hint':
    '临时提高该设备拉取运维指令的轮询频率:挂载后设备下一次轮询(默认间隔下最坏约 5 分钟)进入加速模式,到期自动回落,不需发版。挂载/续期/解除全程写入操作审计。',
  'pages.deviceOps.detail.boost.interval': '轮询频率',
  'pages.deviceOps.detail.boost.duration': '加速时长',
  'pages.deviceOps.detail.boost.5s': '5 秒(推荐)',
  'pages.deviceOps.detail.boost.15s': '15 秒',
  'pages.deviceOps.detail.boost.30s': '30 秒',
  'pages.deviceOps.detail.boost.5m': '5 分钟',
  'pages.deviceOps.detail.boost.10m': '10 分钟(推荐)',
  'pages.deviceOps.detail.boost.15m': '15 分钟',
  'pages.deviceOps.detail.boost.30m': '30 分钟(上限)',
  'pages.deviceOps.detail.boost.reason': '操作原因',
  'pages.deviceOps.detail.boost.reasonRequired': '请填写操作原因(审计必填)',
  'pages.deviceOps.detail.boost.reasonPlaceholder':
    '选填,≤200 字,全程留痕供审计追溯',
  'pages.deviceOps.detail.boost.renewReason': '设备台账详情手动续期加速',

  // ===== 控制台·指令台账抽屉与日志 CSV 导出(2026-10-14 四页合一迁入) =====
  'pages.deviceOps.console.ledger.open': '指令台账',
  'pages.deviceOps.console.ledger.title': '指令台账',
  'pages.deviceOps.console.ledger.allDevices': '全部设备',
  'pages.deviceOps.console.ledger.allDevicesHint':
    '关闭=仅看当前设备的指令;打开=全部设备的指令台账',
  'pages.deviceOps.console.result.exportCsv': '导出 CSV',

  // ===== 控制台·本地库重建导出(2026-10-16;服务端重建 PPOS.db 供 adb 推送恢复) =====
  'pages.deviceOps.console.dbRebuild.open': '本地库重建导出',
  'pages.deviceOps.console.dbRebuild.title': '本地库重建导出',
  'pages.deviceOps.console.dbRebuild.intro':
    '在服务端按条件重建设备本地库并导出 PPOS.db;同设备存在进行中任务时不可重复发起。',
  'pages.deviceOps.console.dbRebuild.device': '目标设备',
  'pages.deviceOps.console.dbRebuild.winRange': '时间窗(门店当地墙钟)',
  'pages.deviceOps.console.dbRebuild.winRangeHint':
    '可选;不选=全量导出;时间按门店当地(马尼拉)墙钟解析',
  'pages.deviceOps.console.dbRebuild.includeReceiptText': '含小票正文',
  'pages.deviceOps.console.dbRebuild.includeReceiptTextHint':
    '关闭可减小导出文件体积',
  'pages.deviceOps.console.dbRebuild.submit': '发起重建',
  'pages.deviceOps.console.dbRebuild.status.RUNNING': '进行中',
  'pages.deviceOps.console.dbRebuild.status.SUCCESS': '已成功',
  'pages.deviceOps.console.dbRebuild.status.FAILED': '已失败',
  'pages.deviceOps.console.dbRebuild.current.title': '当前任务',
  'pages.deviceOps.console.dbRebuild.current.taskNo': '任务单号',
  'pages.deviceOps.console.dbRebuild.current.polling': '每 5s 轮询中…',
  'pages.deviceOps.console.dbRebuild.current.fileSize': '文件大小',
  'pages.deviceOps.console.dbRebuild.current.rowsStats': '行数摘要',
  'pages.deviceOps.console.dbRebuild.current.sha256': 'SHA256',
  'pages.deviceOps.console.dbRebuild.current.errorMsg': '失败原因',
  'pages.deviceOps.console.dbRebuild.download': '下载重建文件',
  'pages.deviceOps.console.dbRebuild.adb.title': 'adb 操作指引',
  'pages.deviceOps.console.dbRebuild.adb.copy': '复制完整命令',
  'pages.deviceOps.console.dbRebuild.history.title': '任务历史',
  'pages.deviceOps.console.dbRebuild.column.taskNo': '任务单号',
  'pages.deviceOps.console.dbRebuild.column.status': '状态',
  'pages.deviceOps.console.dbRebuild.column.fileSize': '文件大小',
  'pages.deviceOps.console.dbRebuild.column.sha256': 'SHA256',
  'pages.deviceOps.console.dbRebuild.column.createTime': '创建时间',
  'pages.deviceOps.console.dbRebuild.column.createBy': '创建人',
  'pages.deviceOps.console.dbRebuild.column.action': '操作',
  'pages.deviceOps.console.dbRebuild.action.download': '下载',
  'pages.deviceOps.console.dbRebuild.msg.pickDevice': '请先选择设备',
  'pages.deviceOps.console.dbRebuild.msg.created': '已发起,任务执行中',
  'pages.deviceOps.console.dbRebuild.msg.downloadFailed': '下载失败',
  'pages.deviceOps.console.dbRebuild.msg.trackingTimeout':
    '本地跟踪超过 5 分钟已停止轮询;最新状态请在任务历史中查看',
};
